import { Box, Typography, Chip, Radio } from 'src/components';

export default function BillingOptions({ options, selected, onSelect }) {
    return (
        <Box sx={{ mt: 1, display: "flex", gap: 2 }}>
            {options.map(({ type, price, subText, highlight, savePercent }) => {
                const isSelected = selected === type;
                return (
                    <Box
                        key={type}
                        onClick={() => onSelect(type)}
                        sx={{
                            flex: 1,
                            p: 2,
                            border: isSelected ? "2px solid" : "1px solid",
                            borderColor: isSelected ? "primary.main" : "#e0e0e0",
                            borderRadius: 2,
                            cursor: "pointer",
                            transform: highlight ? "scale(1.02)" : "scale(1)",
                            boxShadow: highlight
                                ? "0 4px 12px rgba(0,0,0,0.08)"
                                : "0 2px 6px rgba(0,0,0,0.04)",
                            transition: "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
                            position: "relative"
                        }}>

                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                                {type}
                            </Typography>
                            {highlight && (
                                <Chip
                                    label={`Save ${savePercent}%`}
                                    size="small"
                                    color="primary"
                                    sx={{
                                        position: "absolute",
                                        top: -10,
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        height: 18,
                                        fontSize: "0.65rem",
                                        fontWeight: 500,
                                        borderRadius: 50,
                                    }}
                                />
                            )}
                            <Radio checked={isSelected} size="small" />
                        </Box>

                        <Typography variant="subtitle1" sx={{ color: "text.primary", fontWeight: 600, mt: -0.5, mb: 1 }}>
                            {price}
                        </Typography>

                        <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 500, fontSize: "0.8rem" }}>
                            {subText}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
}